<template>
	<div v-if="!!product.redeem_on_dashboard">
		<ui-box :form="refs.buttonLanguageForm" :eager="!!product.id" new-forms>
			<form-subsection title="Button Language" v-if="!hidePre && !hidePost">
				{{ subsectionText }}
			</form-subsection>

			<v-row>
				<v-col md="8" lg="6">
					<v-row>
						<v-col v-if="!hidePre">
							<v-text-field
								v-model="checkInLanguage"
								class="rounded-lg required"
								:hint="beforeHint"
								:label="beforeLabel"
								outlined
								persistent-hint
								required
								:rules="[v => !!v || 'Text is required.']"
							></v-text-field>
						</v-col>
						<v-col v-if="!hidePost && !!afterLabel">
							<v-text-field
								v-model="checkedInLanguage"
								class="rounded-lg required"
								:hint="afterHint"
								:label="afterLabel"
								outlined
								persistent-hint
								required
								:rules="[v => !!v || 'Text is required.']"
							></v-text-field>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</ui-box>
	</div>
</template>

<script>
export default {
	name: 'ButtonLanguageSection',
	props: {
		coupon: {
			type: Object,
			required: true
		},
		partner: {
			type: Object,
			required: true
		},
		product: {
			type: Object,
			required: true
		},
		refs: {
			type: Object,
			required: true
		},
		
		hidePre: {
			type: Boolean,
			default: false,
		},
		hidePost: {
			type: Boolean,
			default: false,
		}
	},
	computed: {
		config() {
			const map = {
				'standard': {
					beforeTag: 'REDEEM',
					afterTag: null,
					beforeLabel: 'Before redemption',
					afterLabel: null,
					beforeHint: 'Text on dashboard buttons before redemption.',
					afterHint: null,
					subsectionText: 'Customize the text shown on dashboard buttons before and after redemption.'
				},
				'check-in': {
					beforeTag: 'CHECKIN',
					afterTag: 'CHECKEDIN',
					beforeLabel: 'Before check-in',
					afterLabel: 'After check-in',
					beforeHint: 'Text on dashboard buttons before being checked in.',
					afterHint: 'Text on dashboard buttons after being checked in.',
					subsectionText: 'Customize the text shown on dashboard buttons before and after check-in.'
				},
				'shipped': {
					beforeTag: 'TAP_TO_SELECT',
					afterTag: null,
					beforeLabel: 'Before selection',
					afterLabel: null,
					beforeHint: 'Text on dashboard buttons before being selected.',
					afterHint: null,
					subsectionText: 'Customize the text shown on dashboard buttons before being selected.'
				}
			};

			return map[this.coupon.redemptions] || {};
		},

		beforeTag() {
			return this.config.beforeTag;
		},
		afterTag() {
			return this.config.afterTag;
		},
		beforeLabel() {
			return this.config.beforeLabel;
		},
		afterLabel() {
			return this.config.afterLabel;
		},
		beforeHint() {
			return this.config.beforeHint;
		},
		afterHint() {
			return this.config.afterHint;
		},
		subsectionText() {
			return this.config.subsectionText;
		},

		checkedInLanguage: {
			get() {
				return this.getLanguageTag(this.afterTag).value;
			},
			set(v) {
				const {coupon: {languageTags}} = this;
				const checkinIndex = this.getLanguageTagIndex(this.afterTag)
				languageTags[checkinIndex].value = v;
			}
		},
		checkInLanguage: {
			get() {
				return this.getLanguageTag(this.beforeTag).value;
			},
			set(v) {
				const {coupon: {languageTags}} = this;
				const checkinIndex = this.getLanguageTagIndex(this.beforeTag)
				languageTags[checkinIndex].value = v;
			}
		},
	},
	methods: {
		getLanguageTag(tag) {
			return this.coupon.languageTags?.find(
				({tag: t}) => t === tag
			) || {value: ''};
		},
		getLanguageTagIndex(tag) {
			const {coupon: {languageTags}} = this;
			return languageTags.findIndex(
				({tag: t}) => t === tag
			);
		},
	}

}
</script>
